import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit',
  templateUrl: './submit.component.html',
  styleUrls: ['./submit.component.scss'],
})
export class SubmitComponent  implements OnInit {

  constructor() { }
  @Input() buttonText?: string="button";
  @Input() buttonDisabled:boolean=false;
  @Input() buttonType?:string="circular";
  @Input() buttonSubmitType?:string="submit"
  ngOnInit() {
    
  }

}
